import React from "react";
import logo from "../assets/images/logo for oceanic/logo.png";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      {/* <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div> */}
      {/* <div className="flex flex-shrink-0 items-center ps-[10px]"> */}
      <img className="h-12 w-[150px]" src={logo} alt="Your Company" />
      {/* </div> */}
    </div>
  );
};

export default Loader;
